import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { COLORS } from 'theme/colors';

const Error = styled.p`
  margin-left: 12px;
  color: ${COLORS.DARK_RED};
  font-size: 14px;
`;

export const InputWrap = ({
  children,
  label,
  error,
}: PropsWithChildren<{
  label: string;
  error?: any;
}>) => (
    <FieldGroup>
      <FieldTitle>{label}</FieldTitle>
      <FieldInputContainer>{children}</FieldInputContainer>
      <ErrorContainer>{error && <Error>{error.message}</Error>}</ErrorContainer>
    </FieldGroup>
  );

const FieldGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 31px;
  width: 100%;
`;

const FieldTitle = styled.div`
  flex: 1;
  margin-right: 12px;
  font-weight: 600;
  text-align: right;
`;

const FieldInputContainer = styled.div`
  flex: 3;
`;

const ErrorContainer = styled.div`
  flex: 2;
`;

export const EditorWrap = ({
  error,
  children,
}: PropsWithChildren<{ error?: any }>) => (
    <EditorGroup>
      {children}
      <EditorErrorContainer>
        {error && <Error>{error.message}</Error>}
      </EditorErrorContainer>
    </EditorGroup>
  );

const EditorGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 8px;
  margin-bottom: 4px;
`;

const EditorErrorContainer = styled.div`
  width: 100%;
  text-align: right;
  margin-top: 8px;
  margin-bottom: 4px;
`;
